import { Chip } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';

function CustomChip(props) {
  const { size, ...restProps } = props;

  const finalTheme = createTheme({
    components: {
      MuiChip: {
        styleOverrides: {
          root: ({ theme }) =>
            theme.unstable_sx({
              px: 1,
              fontSize: `${size * 0.8125}rem`,
              height: `${size * 35}px`,
              borderRadius: '9999px',
            }),

          deleteIcon: ({ theme }) =>
            theme.unstable_sx({
              height: `${size * 22}px`,
              width: `${size * 22}px`,
              color: '#8d00f9',
            }),
        },
      },
    },
  });

  return (
    <ThemeProvider theme={finalTheme}>
      <Chip {...restProps} sx={{ mb: '20px', mr: '15px' }} />
    </ThemeProvider>
  );
}

export default CustomChip;
